module.exports = __webpack_public_path__ + "audio/voice4.m4a";